<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat>
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Money Market Rates</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-iterator
    disable-pagination
    hide-default-footer
    :items="confirmedRates ? Rates : Rates.filter(a => a.CheckerID === 0 && a.state != 'pending')"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:header >
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus(currentRate)">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedRates" @click="newRate()" outlined small color="#2A353D" class="ml-2">
          Add Rate<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedRates" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Money Market Rates.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Money Market Rates.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedRates" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedRates" @click="confirmedRates = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:default="{ items }">
      <div class="pa-3">
        <v-expansion-panels>
          <v-expansion-panel v-for="item in items" :key="item">
            <v-expansion-panel-header>
              <v-row no-gutters>
                <v-col cols="4">
                  {{ item.MMRatesDate | moment("DD MMMM YYYY") }}
                </v-col>
                <v-col cols="4">
                  {{ allCounterparties.filter(a => a.CounterPartyID == item.SellerId).map(a => a.CounterPartyName)[0] }}
                </v-col>
                <v-col cols="4">
                  <v-chip outlined small color="error" v-if="item.RejectionID !== 0 && item.state != 'pending'">rejected</v-chip>
                  <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.state != 'pending'">pending</v-chip>
                  <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0 && item.state != 'pending'">confirmed</v-chip>
                  <v-chip outlined small color="blue" v-if="item.state == 'pending'">new rate</v-chip>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-form class="elevation-0 mt-2" ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col class="py-0">
                    <v-text-field
                      :value="currentSystemDate.DayDate"
                      label="Date"
                      append-icon="mdi-calendar-month"
                      readonly placeholder="--/--/--"
                      dense outlined color="#2A353D"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0">
                    <v-select
                      outlined dense
                      v-model="item.SellerId"
                      :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CounterPartyName"
                      item-value="CounterPartyID"
                      placeholder="----"
                      :rules="TextFieldRules"
                      label="Counterparty"
                    ></v-select>
                  </v-col>
                  <v-col class="py-0">
                    <v-select
                      outlined dense
                      v-model="item.CurrencyId"
                      :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CurrencyName"
                      item-value="CurrencyID"
                      placeholder="----"
                      :rules="TextFieldRules"
                      label="Currency"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>

              <v-tabs light show-arrows v-model="tabs">
                <v-tabs-slider color="#2A353D"></v-tabs-slider>
                <v-tab>1 Day</v-tab>
                <v-tab>7 Days</v-tab>
                <v-tab>14 Days</v-tab>
                <v-tab>21 Days</v-tab>
                <v-tab>30 Days</v-tab>
                <v-tab>60 Days</v-tab>
                <v-tab>90 Days</v-tab>
                <v-tab>120 Days</v-tab>
                <v-tab>180 Days</v-tab>
                <v-tab>270 Days</v-tab>
                <v-tab>365 Days</v-tab>
                <v-tab>366+ Days</v-tab>
              </v-tabs>

              <v-tabs-items class="mt-3" v-model="tabs">
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini001"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate001"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini007"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate007"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini014"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate014"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini021"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate021"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini030"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate030"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini060"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate060"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini090"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate090"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini120"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate120"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini180"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate180"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini270"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate270"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Mini365"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.Rate365"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.MiniPlus"
                        label="Minimum"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        v-model="item.RatePlus"
                        label="Rate"
                        type="number" placeholder="----"
                        dense outlined light
                        color="#2A353D"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>

              <div class="text-right">
                <v-tooltip v-if="!confirmedRates && item.CheckerID == 0" top>
                  <template v-slot:activator="{ on }">
                  <v-btn
                    small @click="updateStatus(item)"
                    outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
                    v-on="on"
                    color="#2A353D" class="mr-3"
                  >
                    confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
                  </v-btn>
                  </template>
                  <span>confirm</span>
                </v-tooltip>
                <v-tooltip v-if="!confirmedRates && item.CheckerID == 0" top>
                  <template v-slot:activator="{ on }">
                  <v-btn
                    small @click="setActiveRate(item, index); rejectionDialog = true"
                    outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
                    v-on="on"
                    color="#2A353D" class="mr-3"
                  >
                    reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
                  </v-btn>
                  </template>
                  <span>reject</span>
                </v-tooltip>
                <v-btn
                  v-show="confirmedRates"
                  small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID && item.state != 'pending' : showEditBtn == true && item.state != 'pending'"
                  @click="update(item)" :disabled="!valid"
                  color="#2A353D" class="mr-3"
                >
                  <span>save</span>
                </v-btn>
                <v-btn
                  v-show="confirmedRates"
                  small outlined v-if="item.state == 'pending'"
                  @click="createNew(item)" :disabled="!valid"
                  color="#2A353D" class="mr-3"
                >
                  <span>create</span>
                </v-btn>
                <v-btn
                  v-show="confirmedRates"
                  v-if="item.state != 'pending'" small outlined
                  :disabled="(item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0) || showDeleteBtn == false ? false : true"
                  color="#2A353D" @click="setActiveRate(item, index); deleteDialog = true"
                >
                delete
                </v-btn>
                <v-btn
                  v-else small outlined
                  color="#2A353D" @click="removeRate(item)"
                >
                delete
                </v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </template>
  </v-data-iterator>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'Money Market Rates',

  data () {
    return {
      confirmedRates: true,
      edit: false,
      create: false,
      view: false,
      rejectionDialog: false,
      deleteDialog: false,
      permitted: null,
      permitted_dialog: true,
      RejectionStatus: 0,
      tabs: 0,
      message: '',
      search: '',
      valid: true,
      content: '',
      currentRate: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Activation Code',
          align: 'start',
          sortable: true,
          value: 'ActivationCode'
        },
        { text: 'Reason', value: 'ActivationReason', sortable: false },
        { text: 'Date created', value: 'MakeDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      Rates: [],
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allMMRates",
      "allRejectionReasons",
      "allUsers",
      "allCounterparties",
      "allCurrencies",
      "allApplicationDefaults",
      "currentSystemDate",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 401).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createMMRate",
      "updateMMRate",
      "deleteMMRate"
    ]),

    async createNew(item) {
      this.message = '';
      if(item.CurrencyId != null && item.SellerId != null){
        item.MakerID = this.currentUser.SecurityUserID,
        item.CheckerID = this.CheckerID,
        item.LastUserID = this.currentUser.SecurityUserID,
        this.createMMRate(item)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newMMRate',
            data: response.data
          });
          this.message = response.data.message
          this.removeRate(item)
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      } else {
        this.message = "Counterparty and Currency cannot be null!!"
      }
    },

    async update(item) {
      this.message = '';
      if(item.CurrencyId != null && item.SellerId != null){
        if(item.CheckerID == 0){
          item.LastUserID = this.currentUser.SecurityUserID,
          item.RejectionID = this.RejectionStatus,
          item.CheckerID = 0,
          item.CheckDate = null,

          this.updateMMRate(item)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updMMRate',
              data: item
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          item.MakerID = this.currentUser.SecurityUserID
          item.LastUserID = this.currentUser.SecurityUserID,
          item.RejectionID = this.RejectionStatus,
          item.CheckerID = 0,
          item.CheckDate = null,
          item.MakeDate = new Date(),

          this.updateMMRate(item)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updMMRate',
              data: item
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      } else {
        this.message = "Counterparty and Currency cannot be null!!"
      }
    },

    deleteItem() {
      this.message = '';

      this.deleteMMRate(this.currentRate)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltMMRate',
          data: this.currentRate
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    updateStatus(item) {
      this.message = '';

      item.CheckerID = this.currentUser.SecurityUserID,
      item.LastUserID = this.currentUser.SecurityUserID,
      item.RejectionID = this.RejectionStatus,
      item.CheckDate = new Date(),
      item.updatedAt = new Date(),

      this.updateMMRate(item)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updMMRate',
          data: item
        });
        
        this.message = response.data.message
        this.RejectionStatus = 0
        this.rejectionDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Money Market Rates", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Money Market Rates.pdf')
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedRates = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.activation = {};
      this.create = false
    },

    newRate() {
      this.Rates.unshift({
        MMRatesDate: this.currentSystemDate.DayDate,
        SellerId: null,
        CurrencyId: null,
        Mini001: 0,
        Rate001: 0,
        Mini007: 0,
        Rate007: 0,
        Mini014: 0,
        Rate014: 0,
        Mini021: 0,
        Rate021: 0,
        Mini030: 0,
        Rate030: 0,
        Mini060: 0,
        Rate060: 0,
        Mini090: 0,
        Rate090: 0,
        Mini120: 0,
        Rate120: 0,
        Mini180: 0,
        Rate180: 0,
        Mini270: 0,
        Rate270: 0,
        Mini365: 0,
        Rate365: 0,
        MiniPlus: 0,
        RatePlus: 0,
        state: 'pending'
      })
    },

    removeRate(item){
      const index = this.Rates.findIndex(r => r.state == 'pending' && r.SellerId == item.SellerId && r.CurrencyId == item.CurrencyId);
      this.Rates.splice(index, 1)
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveRate (item, index) {
      this.currentRate = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isRates().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.Rates = this.allMMRates;
    this.$root.$on("unconfirmedMMRates", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
